<template>
	<PageLoading :loading="cases.loading" class="relative mt-4">
		<LiveBubbles />
		<PageTitle>{{ t('title') }}</PageTitle>
		<PagePillRow class="mt-4">
			<SearchButton v-model="cases.search" />
			<BaseButton
				color="secondary"
				size="md"
				@click="cases.toggleSort"
				class="snap-start"
			>
				<SortIcon
					class="h-5 w-5 transition-transform"
					:class="{ 'rotate-180': !cases.sortExpensive }"
				/>
				<div>{{ sortText }}</div>
			</BaseButton>
			<div class="bg-separator-secondary mx-2 h-4 w-px"></div>
			<TagGroup class="*:snap-start" v-model="cases.selectedTag" :tags="tags" />
		</PagePillRow>
		<PagePadding
			class="mt-4 grid grid-cols-2 gap-1.5 min-[480px]:grid-cols-3 min-[720px]:grid-cols-4 min-[960px]:grid-cols-5"
			v-if="cases.sorted.length"
		>
			<RouterLink
				:to="`/case/${item.uuid}`"
				custom
				v-slot="{ navigate }"
				v-for="item in cases.sorted"
			>
				<CaseCard
					:risk="item.risk"
					:price="item.price"
					:uuid="item.uuid"
					:name="item.name"
					@click="navigate"
				/>
			</RouterLink>
		</PagePadding>
		<PageEmpty :title="t('empty.title')" :desc="t('empty.desc')" v-else>
			<BaseButton size="lg" color="secondary" @click="reset">
				{{ t('reset') }}
			</BaseButton>
		</PageEmpty>
	</PageLoading>
</template>
<script setup lang="ts">
import BaseButton from '@/components/BaseButton.vue'
import CaseCard from '@/components/CaseCard.vue'
import PagePadding from '@/components/PagePadding.vue'
import PageTitle from '@/components/PageTitle.vue'
import SortIcon from '@/assets/icons/sort.svg'
import AllIcon from '@/assets/icons/all.svg'
import LowRiskIcon from '@/assets/icons/low-risk.svg'
import MediumRiskIcon from '@/assets/icons/medium-risk.svg'
import HighRiskIcon from '@/assets/icons/high-risk.svg'
import TagGroup from '@/components/TagGroup.vue'
import LiveBubbles from '@/components/LiveBubbles.vue'
import { useLayout } from '@/stores/layout'
import PagePillRow from '@/components/PagePillRow.vue'
import SearchButton from '@/components/SearchButton.vue'
import { useCases } from '@/stores/cases'
import PageLoading from '@/components/PageLoading.vue'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import PageEmpty from '@/components/PageEmpty.vue'

const cases = useCases()

const layout = useLayout()

layout.showBottomNavbar()

const { t } = useI18n({
	messages: {
		en: {
			title: 'unboxing',
			filters: {
				all: 'All Cases',
				low: 'Low risk',
				medium: 'Medium risk',
				high: 'High risk'
			},
			sort: {
				expensive: 'Expensive first',
				cheap: 'Cheap first'
			},
			empty: {
				title: 'no cases found',
				desc: 'Try adjusting your filters'
			},
			reset: 'reset filters'
		},
		ru: {
			title: 'кейсы',
			filters: {
				all: 'Все кейсы',
				low: 'Низкий риск',
				medium: 'Средний риск',
				high: 'Высокий риск'
			},
			sort: {
				expensive: 'Сначала дорогие',
				cheap: 'Сначала дешевые'
			},
			empty: {
				title: 'кейсов не найдено',
				desc: 'Попробуй изменить фильтры'
			},
			reset: 'сбросить фильтры'
		}
	}
})

const tags = computed(() => [
	{ text: t('filters.all'), icon: AllIcon },
	{ text: t('filters.low'), icon: LowRiskIcon },
	{ text: t('filters.medium'), icon: MediumRiskIcon },
	{ text: t('filters.high'), icon: HighRiskIcon }
])

const sortText = computed(() => {
	return cases.sortExpensive ? t('sort.expensive') : t('sort.cheap')
})

const reset = () => {
	cases.search = ''
	cases.selectedTag = 0
}
</script>
